// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(6 172 241 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(6 172 241 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  
}
.tw-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0
}
.tw-pointer-events-none {
    pointer-events: none
}
.tw-fixed {
    position: fixed
}
.tw-absolute {
    position: absolute
}
.tw-relative {
    position: relative
}
.tw-inset-0 {
    inset: 0px
}
.tw-inset-x-0 {
    left: 0px;
    right: 0px
}
.tw-bottom-0 {
    bottom: 0px
}
.tw-bottom-10 {
    bottom: 2.5rem
}
.tw-bottom-2 {
    bottom: 0.5rem
}
.tw-bottom-6 {
    bottom: 1.5rem
}
.tw-bottom-\\[-10px\\] {
    bottom: -10px
}
.tw-bottom-\\[-5px\\] {
    bottom: -5px
}
.tw-bottom-full {
    bottom: 100%
}
.tw-left-0 {
    left: 0px
}
.tw-left-1\\/2 {
    left: 50%
}
.tw-left-3 {
    left: 0.75rem
}
.tw-left-full {
    left: 100%
}
.tw-right-0 {
    right: 0px
}
.tw-right-10 {
    right: 2.5rem
}
.tw-right-2 {
    right: 0.5rem
}
.tw-right-3 {
    right: 0.75rem
}
.tw-right-4 {
    right: 1rem
}
.tw-right-6 {
    right: 1.5rem
}
.tw-right-\\[-10px\\] {
    right: -10px
}
.tw-right-\\[-5px\\] {
    right: -5px
}
.tw-right-\\[-8px\\] {
    right: -8px
}
.tw-top-0 {
    top: 0px
}
.tw-top-1\\/2 {
    top: 50%
}
.tw-top-2 {
    top: 0.5rem
}
.tw-top-3 {
    top: 0.75rem
}
.tw-top-4 {
    top: 1rem
}
.tw-top-\\[-26px\\] {
    top: -26px
}
.tw-top-\\[-4px\\] {
    top: -4px
}
.tw-top-\\[150\\%\\] {
    top: 150%
}
.tw-top-\\[36px\\] {
    top: 36px
}
.tw-top-\\[50px\\] {
    top: 50px
}
.tw-top-\\[60px\\] {
    top: 60px
}
.-tw-z-10 {
    z-index: -10
}
.tw-z-0 {
    z-index: 0
}
.tw-z-10 {
    z-index: 10
}
.tw-z-20 {
    z-index: 20
}
.tw-z-50 {
    z-index: 50
}
.tw-z-\\[40\\] {
    z-index: 40
}
.tw-col-span-2 {
    grid-column: span 2 / span 2
}
.tw-col-span-3 {
    grid-column: span 3 / span 3
}
.tw-col-span-4 {
    grid-column: span 4 / span 4
}
.tw-col-span-6 {
    grid-column: span 6 / span 6
}
.tw-m-0 {
    margin: 0px
}
.tw-m-10 {
    margin: 2.5rem
}
.tw-m-auto {
    margin: auto
}
.tw-mx-0 {
    margin-left: 0px;
    margin-right: 0px
}
.tw-mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem
}
.tw-mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem
}
.tw-mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem
}
.tw-mx-4 {
    margin-left: 1rem;
    margin-right: 1rem
}
.tw-mx-auto {
    margin-left: auto;
    margin-right: auto
}
.tw-my-0 {
    margin-top: 0px;
    margin-bottom: 0px
}
.tw-my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem
}
.tw-my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem
}
.tw-my-24 {
    margin-top: 6rem;
    margin-bottom: 6rem
}
.tw-my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem
}
.tw-my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem
}
.tw-my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem
}
.tw-my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem
}
.tw-my-9 {
    margin-top: 2.25rem;
    margin-bottom: 2.25rem
}
.-tw-ml-1 {
    margin-left: -0.25rem
}
.-tw-ml-48 {
    margin-left: -12rem
}
.-tw-mt-32 {
    margin-top: -8rem
}
.tw-mb-0 {
    margin-bottom: 0px
}
.tw-mb-1 {
    margin-bottom: 0.25rem
}
.tw-mb-10 {
    margin-bottom: 2.5rem
}
.tw-mb-2 {
    margin-bottom: 0.5rem
}
.tw-mb-3 {
    margin-bottom: 0.75rem
}
.tw-mb-4 {
    margin-bottom: 1rem
}
.tw-mb-5 {
    margin-bottom: 1.25rem
}
.tw-mb-6 {
    margin-bottom: 1.5rem
}
.tw-mb-8 {
    margin-bottom: 2rem
}
.tw-me-2 {
    margin-inline-end: 0.5rem
}
.tw-ml-0 {
    margin-left: 0px
}
.tw-ml-1 {
    margin-left: 0.25rem
}
.tw-ml-10 {
    margin-left: 2.5rem
}
.tw-ml-16 {
    margin-left: 4rem
}
.tw-ml-2 {
    margin-left: 0.5rem
}
.tw-ml-3 {
    margin-left: 0.75rem
}
.tw-ml-4 {
    margin-left: 1rem
}
.tw-ml-5 {
    margin-left: 1.25rem
}
.tw-ml-6 {
    margin-left: 1.5rem
}
.tw-mr-1 {
    margin-right: 0.25rem
}
.tw-mr-10 {
    margin-right: 2.5rem
}
.tw-mr-16 {
    margin-right: 4rem
}
.tw-mr-2 {
    margin-right: 0.5rem
}
.tw-mr-20 {
    margin-right: 5rem
}
.tw-mr-3 {
    margin-right: 0.75rem
}
.tw-mr-4 {
    margin-right: 1rem
}
.tw-mr-5 {
    margin-right: 1.25rem
}
.tw-mr-6 {
    margin-right: 1.5rem
}
.tw-mr-8 {
    margin-right: 2rem
}
.tw-mt-0 {
    margin-top: 0px
}
.tw-mt-1 {
    margin-top: 0.25rem
}
.tw-mt-10 {
    margin-top: 2.5rem
}
.tw-mt-2 {
    margin-top: 0.5rem
}
.tw-mt-20 {
    margin-top: 5rem
}
.tw-mt-24 {
    margin-top: 6rem
}
.tw-mt-3 {
    margin-top: 0.75rem
}
.tw-mt-4 {
    margin-top: 1rem
}
.tw-mt-5 {
    margin-top: 1.25rem
}
.tw-mt-6 {
    margin-top: 1.5rem
}
.tw-mt-7 {
    margin-top: 1.75rem
}
.tw-mt-8 {
    margin-top: 2rem
}
.tw-block {
    display: block
}
.tw-inline-block {
    display: inline-block
}
.tw-flex {
    display: flex
}
.tw-inline-flex {
    display: inline-flex
}
.tw-grid {
    display: grid
}
.tw-hidden {
    display: none
}
.tw-size-full {
    width: 100%;
    height: 100%
}
.tw-h-1\\/2 {
    height: 50%
}
.tw-h-10 {
    height: 2.5rem
}
.tw-h-12 {
    height: 3rem
}
.tw-h-2 {
    height: 0.5rem
}
.tw-h-20 {
    height: 5rem
}
.tw-h-3 {
    height: 0.75rem
}
.tw-h-32 {
    height: 8rem
}
.tw-h-4 {
    height: 1rem
}
.tw-h-44 {
    height: 11rem
}
.tw-h-5 {
    height: 1.25rem
}
.tw-h-6 {
    height: 1.5rem
}
.tw-h-64 {
    height: 16rem
}
.tw-h-7 {
    height: 1.75rem
}
.tw-h-8 {
    height: 2rem
}
.tw-h-9 {
    height: 2.25rem
}
.tw-h-96 {
    height: 24rem
}
.tw-h-\\[1000px\\] {
    height: 1000px
}
.tw-h-\\[100px\\] {
    height: 100px
}
.tw-h-\\[150px\\] {
    height: 150px
}
.tw-h-\\[200px\\] {
    height: 200px
}
.tw-h-\\[210px\\] {
    height: 210px
}
.tw-h-\\[250px\\] {
    height: 250px
}
.tw-h-\\[26px\\] {
    height: 26px
}
.tw-h-\\[27px\\] {
    height: 27px
}
.tw-h-\\[280px\\] {
    height: 280px
}
.tw-h-\\[28px\\] {
    height: 28px
}
.tw-h-\\[290px\\] {
    height: 290px
}
.tw-h-\\[300px\\] {
    height: 300px
}
.tw-h-\\[30px\\] {
    height: 30px
}
.tw-h-\\[324px\\] {
    height: 324px
}
.tw-h-\\[32px\\] {
    height: 32px
}
.tw-h-\\[348px\\] {
    height: 348px
}
.tw-h-\\[34px\\] {
    height: 34px
}
.tw-h-\\[350px\\] {
    height: 350px
}
.tw-h-\\[35px\\] {
    height: 35px
}
.tw-h-\\[36px\\] {
    height: 36px
}
.tw-h-\\[38px\\] {
    height: 38px
}
.tw-h-\\[400px\\] {
    height: 400px
}
.tw-h-\\[40px\\] {
    height: 40px
}
.tw-h-\\[42px\\] {
    height: 42px
}
.tw-h-\\[45px\\] {
    height: 45px
}
.tw-h-\\[46px\\] {
    height: 46px
}
.tw-h-\\[480px\\] {
    height: 480px
}
.tw-h-\\[500px\\] {
    height: 500px
}
.tw-h-\\[50px\\] {
    height: 50px
}
.tw-h-\\[50vh\\] {
    height: 50vh
}
.tw-h-\\[580px\\] {
    height: 580px
}
.tw-h-\\[600px\\] {
    height: 600px
}
.tw-h-\\[60px\\] {
    height: 60px
}
.tw-h-\\[60vh\\] {
    height: 60vh
}
.tw-h-\\[64px\\] {
    height: 64px
}
.tw-h-\\[682px\\] {
    height: 682px
}
.tw-h-\\[75vh\\] {
    height: 75vh
}
.tw-h-\\[calc\\(100\\%_-_130px\\)\\] {
    height: calc(100% - 130px)
}
.tw-h-\\[calc\\(100vh-180px\\)\\] {
    height: calc(100vh - 180px)
}
.tw-h-\\[calc\\(100vh_-_168px\\)\\] {
    height: calc(100vh - 168px)
}
.tw-h-\\[calc\\(100vh_-_210px\\)\\] {
    height: calc(100vh - 210px)
}
.tw-h-\\[calc\\(100vh_-_240px\\)\\] {
    height: calc(100vh - 240px)
}
.tw-h-\\[calc\\(100vh_-_60px\\)\\] {
    height: calc(100vh - 60px)
}
.tw-h-auto {
    height: auto
}
.tw-h-full {
    height: 100%
}
.tw-h-px {
    height: 1px
}
.tw-h-screen {
    height: 100vh
}
.tw-max-h-0 {
    max-height: 0px
}
.tw-max-h-32 {
    max-height: 8rem
}
.tw-max-h-56 {
    max-height: 14rem
}
.tw-max-h-60 {
    max-height: 15rem
}
.tw-max-h-96 {
    max-height: 24rem
}
.tw-max-h-\\[100px\\] {
    max-height: 100px
}
.tw-max-h-\\[180px\\] {
    max-height: 180px
}
.tw-max-h-\\[350px\\] {
    max-height: 350px
}
.tw-max-h-\\[400px\\] {
    max-height: 400px
}
.tw-max-h-\\[500px\\] {
    max-height: 500px
}
.tw-max-h-\\[90vh\\] {
    max-height: 90vh
}
.tw-max-h-\\[calc\\(100vh_-_400px\\)\\] {
    max-height: calc(100vh - 400px)
}
.tw-max-h-full {
    max-height: 100%
}
.tw-max-h-screen {
    max-height: 100vh
}
.tw-min-h-\\[100px\\] {
    min-height: 100px
}
.tw-min-h-\\[310px\\] {
    min-height: 310px
}
.tw-min-h-\\[40px\\] {
    min-height: 40px
}
.tw-min-h-\\[50px\\] {
    min-height: 50px
}
.tw-min-h-\\[600px\\] {
    min-height: 600px
}
.tw-min-h-\\[60px\\] {
    min-height: 60px
}
.tw-min-h-full {
    min-height: 100%
}
.tw-w-1\\/12 {
    width: 8.333333%
}
.tw-w-1\\/2 {
    width: 50%
}
.tw-w-1\\/3 {
    width: 33.333333%
}
.tw-w-1\\/5 {
    width: 20%
}
.tw-w-1\\/6 {
    width: 16.666667%
}
.tw-w-10 {
    width: 2.5rem
}
.tw-w-10\\/12 {
    width: 83.333333%
}
.tw-w-11 {
    width: 2.75rem
}
.tw-w-12 {
    width: 3rem
}
.tw-w-2\\/12 {
    width: 16.666667%
}
.tw-w-2\\/3 {
    width: 66.666667%
}
.tw-w-2\\/5 {
    width: 40%
}
.tw-w-2\\/6 {
    width: 33.333333%
}
.tw-w-20 {
    width: 5rem
}
.tw-w-24 {
    width: 6rem
}
.tw-w-3 {
    width: 0.75rem
}
.tw-w-3\\/12 {
    width: 25%
}
.tw-w-3\\/4 {
    width: 75%
}
.tw-w-3\\/5 {
    width: 60%
}
.tw-w-3\\/6 {
    width: 50%
}
.tw-w-32 {
    width: 8rem
}
.tw-w-4 {
    width: 1rem
}
.tw-w-4\\/12 {
    width: 33.333333%
}
.tw-w-4\\/5 {
    width: 80%
}
.tw-w-4\\/6 {
    width: 66.666667%
}
.tw-w-40 {
    width: 10rem
}
.tw-w-48 {
    width: 12rem
}
.tw-w-5 {
    width: 1.25rem
}
.tw-w-5\\/6 {
    width: 83.333333%
}
.tw-w-52 {
    width: 13rem
}
.tw-w-6 {
    width: 1.5rem
}
.tw-w-6\\/12 {
    width: 50%
}
.tw-w-60 {
    width: 15rem
}
.tw-w-64 {
    width: 16rem
}
.tw-w-7 {
    width: 1.75rem
}
.tw-w-7\\/12 {
    width: 58.333333%
}
.tw-w-8 {
    width: 2rem
}
.tw-w-8\\/12 {
    width: 66.666667%
}
.tw-w-80 {
    width: 20rem
}
.tw-w-\\[100\\%\\] {
    width: 100%
}
.tw-w-\\[1024px\\] {
    width: 1024px
}
.tw-w-\\[140px\\] {
    width: 140px
}
.tw-w-\\[150px\\] {
    width: 150px
}
.tw-w-\\[160px\\] {
    width: 160px
}
.tw-w-\\[178px\\] {
    width: 178px
}
.tw-w-\\[200px\\] {
    width: 200px
}
.tw-w-\\[240px\\] {
    width: 240px
}
.tw-w-\\[250px\\] {
    width: 250px
}
.tw-w-\\[26px\\] {
    width: 26px
}
.tw-w-\\[27px\\] {
    width: 27px
}
.tw-w-\\[280px\\] {
    width: 280px
}
.tw-w-\\[281px\\] {
    width: 281px
}
.tw-w-\\[28px\\] {
    width: 28px
}
.tw-w-\\[291px\\] {
    width: 291px
}
.tw-w-\\[30\\%\\] {
    width: 30%
}
.tw-w-\\[30px\\] {
    width: 30px
}
.tw-w-\\[32px\\] {
    width: 32px
}
.tw-w-\\[34px\\] {
    width: 34px
}
.tw-w-\\[350px\\] {
    width: 350px
}
.tw-w-\\[355px\\] {
    width: 355px
}
.tw-w-\\[35px\\] {
    width: 35px
}
.tw-w-\\[400px\\] {
    width: 400px
}
.tw-w-\\[40px\\] {
    width: 40px
}
.tw-w-\\[42px\\] {
    width: 42px
}
.tw-w-\\[450px\\] {
    width: 450px
}
.tw-w-\\[46px\\] {
    width: 46px
}
.tw-w-\\[474px\\] {
    width: 474px
}
.tw-w-\\[475px\\] {
    width: 475px
}
.tw-w-\\[50\\%\\] {
    width: 50%
}
.tw-w-\\[500px\\] {
    width: 500px
}
.tw-w-\\[50px\\] {
    width: 50px
}
.tw-w-\\[526px\\] {
    width: 526px
}
.tw-w-\\[546px\\] {
    width: 546px
}
.tw-w-\\[60px\\] {
    width: 60px
}
.tw-w-\\[634px\\] {
    width: 634px
}
.tw-w-\\[64px\\] {
    width: 64px
}
.tw-w-\\[70px\\] {
    width: 70px
}
.tw-w-\\[816px\\] {
    width: 816px
}
.tw-w-\\[850px\\] {
    width: 850px
}
.tw-w-\\[9\\%\\] {
    width: 9%
}
.tw-w-\\[90\\%\\] {
    width: 90%
}
.tw-w-\\[95\\%\\] {
    width: 95%
}
.tw-w-\\[95px\\] {
    width: 95px
}
.tw-w-auto {
    width: auto
}
.tw-w-fit {
    width: fit-content
}
.tw-w-full {
    width: 100%
}
.tw-w-max {
    width: max-content
}
.tw-w-screen {
    width: 100vw
}
.tw-min-w-0 {
    min-width: 0px
}
.tw-min-w-\\[100px\\] {
    min-width: 100px
}
.tw-min-w-\\[150px\\] {
    min-width: 150px
}
.tw-min-w-\\[160px\\] {
    min-width: 160px
}
.tw-min-w-\\[350px\\] {
    min-width: 350px
}
.tw-min-w-\\[600px\\] {
    min-width: 600px
}
.tw-min-w-\\[60px\\] {
    min-width: 60px
}
.tw-min-w-\\[80px\\] {
    min-width: 80px
}
.tw-min-w-full {
    min-width: 100%
}
.tw-max-w-3xl {
    max-width: 48rem
}
.tw-max-w-5xl {
    max-width: 64rem
}
.tw-max-w-6xl {
    max-width: 72rem
}
.tw-max-w-\\[108px\\] {
    max-width: 108px
}
.tw-max-w-\\[1140px\\] {
    max-width: 1140px
}
.tw-max-w-\\[140px\\] {
    max-width: 140px
}
.tw-max-w-\\[190px\\] {
    max-width: 190px
}
.tw-max-w-\\[200px\\] {
    max-width: 200px
}
.tw-max-w-\\[240px\\] {
    max-width: 240px
}
.tw-max-w-\\[350px\\] {
    max-width: 350px
}
.tw-max-w-\\[400px\\] {
    max-width: 400px
}
.tw-max-w-\\[90vw\\] {
    max-width: 90vw
}
.tw-max-w-lg {
    max-width: 32rem
}
.tw-max-w-sm {
    max-width: 24rem
}
.tw-max-w-xl {
    max-width: 36rem
}
.tw-max-w-xs {
    max-width: 20rem
}
.tw-flex-1 {
    flex: 1 1
}
.tw-flex-none {
    flex: none
}
.tw-flex-shrink-0 {
    flex-shrink: 0
}
.tw-flex-grow {
    flex-grow: 1
}
.tw-table-auto {
    table-layout: auto
}
.tw-table-fixed {
    table-layout: fixed
}
.tw-border-collapse {
    border-collapse: collapse
}
.tw-border-separate {
    border-collapse: separate
}
.tw-border-spacing-y-3 {
    --tw-border-spacing-y: 0.75rem;
    border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y)
}
.-tw-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.tw--translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.tw--translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.tw-translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.tw-translate-x-5 {
    --tw-translate-x: 1.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.tw-rotate-0 {
    --tw-rotate: 0deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.tw-rotate-180 {
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.tw-rotate-\\[-90deg\\] {
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.tw-transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
@keyframes tw-accordion-down {
    from {
        height: 0
    }
    to {
        height: var(--radix-accordion-content-height)
    }
}
.tw-animate-accordion-down {
    animation: tw-accordion-down 0.2s ease-out
}
@keyframes tw-accordion-up {
    from {
        height: var(--radix-accordion-content-height)
    }
    to {
        height: 0
    }
}
.tw-animate-accordion-up {
    animation: tw-accordion-up 0.2s ease-out
}
@keyframes tw-pulse {
    50% {
        opacity: .5
    }
}
.tw-animate-pulse {
    animation: tw-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite
}
@keyframes tw-spin {
    to {
        transform: rotate(360deg)
    }
}
.tw-animate-spin {
    animation: tw-spin 1s linear infinite
}
.tw-cursor-default {
    cursor: default
}
.tw-cursor-move {
    cursor: move
}
.tw-cursor-not-allowed {
    cursor: not-allowed
}
.tw-cursor-pointer {
    cursor: pointer
}
.tw-resize-y {
    resize: vertical
}
.tw-list-decimal {
    list-style-type: decimal
}
.tw-list-none {
    list-style-type: none
}
.tw-appearance-none {
    appearance: none
}
.tw-grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr))
}
.tw-grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr))
}
.tw-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr))
}
.tw-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr))
}
.tw-grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr))
}
.tw-grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr))
}
.tw-grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr))
}
.tw-grid-cols-\\[40px_2fr\\] {
    grid-template-columns: 40px 2fr
}
.tw-grid-cols-\\[40px_2fr_1fr_1fr_1fr_1fr\\] {
    grid-template-columns: 40px 2fr 1fr 1fr 1fr 1fr
}
.tw-grid-cols-\\[40px_60px_2fr_1\\.2fr_90px_110px\\] {
    grid-template-columns: 40px 60px 2fr 1.2fr 90px 110px
}
.tw-grid-cols-\\[60px_2fr_1\\.2fr_2fr\\] {
    grid-template-columns: 60px 2fr 1.2fr 2fr
}
.tw-grid-rows-\\[0fr\\] {
    grid-template-rows: 0fr
}
.tw-grid-rows-\\[1fr\\] {
    grid-template-rows: 1fr
}
.tw-flex-row {
    flex-direction: row
}
.tw-flex-col {
    flex-direction: column
}
.tw-flex-wrap {
    flex-wrap: wrap
}
.tw-flex-nowrap {
    flex-wrap: nowrap
}
.tw-place-items-start {
    place-items: start
}
.tw-place-items-center {
    place-items: center
}
.tw-content-end {
    align-content: flex-end
}
.tw-items-start {
    align-items: flex-start
}
.tw-items-end {
    align-items: flex-end
}
.tw-items-center {
    align-items: center
}
.tw-justify-start {
    justify-content: flex-start
}
.tw-justify-end {
    justify-content: flex-end
}
.tw-justify-center {
    justify-content: center
}
.tw-justify-between {
    justify-content: space-between
}
.tw-gap-1 {
    gap: 0.25rem
}
.tw-gap-10 {
    gap: 2.5rem
}
.tw-gap-14 {
    gap: 3.5rem
}
.tw-gap-2 {
    gap: 0.5rem
}
.tw-gap-3 {
    gap: 0.75rem
}
.tw-gap-4 {
    gap: 1rem
}
.tw-gap-5 {
    gap: 1.25rem
}
.tw-gap-6 {
    gap: 1.5rem
}
.tw-gap-8 {
    gap: 2rem
}
.tw-gap-x-2 {
    column-gap: 0.5rem
}
.tw-gap-y-3 {
    row-gap: 0.75rem
}
.tw-space-x-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)))
}
.tw-space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))
}
.tw-space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)))
}
.tw-space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)))
}
.tw-space-x-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)))
}
.tw-space-x-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)))
}
.tw-space-x-9 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--tw-space-x-reverse));
    margin-left: calc(2.25rem * calc(1 - var(--tw-space-x-reverse)))
}
.tw-space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse))
}
.tw-space-y-10 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--tw-space-y-reverse))
}
.tw-space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse))
}
.tw-space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse))
}
.tw-space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse))
}
.tw-space-y-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse))
}
.tw-space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse))
}
.tw-space-y-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse))
}
.tw-space-y-9 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--tw-space-y-reverse))
}
.tw-divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse))
}
.tw-overflow-auto {
    overflow: auto
}
.tw-overflow-hidden {
    overflow: hidden
}
.tw-overflow-x-auto {
    overflow-x: auto
}
.tw-overflow-y-auto {
    overflow-y: auto
}
.tw-overflow-x-hidden {
    overflow-x: hidden
}
.tw-overflow-y-scroll {
    overflow-y: scroll
}
.tw-scroll-smooth {
    scroll-behavior: smooth
}
.tw-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}
.tw-whitespace-nowrap {
    white-space: nowrap
}
.tw-break-words {
    overflow-wrap: break-word
}
.tw-break-all {
    word-break: break-all
}
.tw-rounded {
    border-radius: 0.25rem
}
.tw-rounded-2xl {
    border-radius: 1rem
}
.tw-rounded-3xl {
    border-radius: 1.5rem
}
.tw-rounded-full {
    border-radius: 9999px
}
.tw-rounded-lg {
    border-radius: 0.5rem
}
.tw-rounded-md {
    border-radius: 0.375rem
}
.tw-rounded-none {
    border-radius: 0px
}
.tw-rounded-sm {
    border-radius: 0.125rem
}
.tw-rounded-xl {
    border-radius: 0.75rem
}
.tw-rounded-b-xl {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem
}
.tw-rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px
}
.tw-rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem
}
.tw-rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem
}
.tw-border {
    border-width: 1px
}
.tw-border-2 {
    border-width: 2px
}
.tw-border-4 {
    border-width: 4px
}
.tw-border-y {
    border-top-width: 1px;
    border-bottom-width: 1px
}
.tw-border-b {
    border-bottom-width: 1px
}
.tw-border-b-0 {
    border-bottom-width: 0px
}
.tw-border-r {
    border-right-width: 1px
}
.tw-border-t {
    border-top-width: 1px
}
.tw-border-solid {
    border-style: solid
}
.tw-border-dashed {
    border-style: dashed
}
.tw-border-none {
    border-style: none
}
.tw-border-\\[\\#4F46E5\\] {
    --tw-border-opacity: 1;
    border-color: rgb(79 70 229 / var(--tw-border-opacity, 1))
}
.tw-border-black {
    --tw-border-opacity: 1;
    border-color: rgb(3 6 23 / var(--tw-border-opacity, 1))
}
.tw-border-gray-100 {
    --tw-border-opacity: 1;
    border-color: rgb(241 245 249 / var(--tw-border-opacity, 1))
}
.tw-border-gray-200 {
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1))
}
.tw-border-gray-300 {
    --tw-border-opacity: 1;
    border-color: rgb(203 213 225 / var(--tw-border-opacity, 1))
}
.tw-border-gray-400 {
    --tw-border-opacity: 1;
    border-color: rgb(148 163 184 / var(--tw-border-opacity, 1))
}
.tw-border-gray-500 {
    --tw-border-opacity: 1;
    border-color: rgb(100 116 139 / var(--tw-border-opacity, 1))
}
.tw-border-purple-200 {
    --tw-border-opacity: 1;
    border-color: rgb(202 205 251 / var(--tw-border-opacity, 1))
}
.tw-border-purple-400 {
    --tw-border-opacity: 1;
    border-color: rgb(141 136 241 / var(--tw-border-opacity, 1))
}
.tw-border-purple-500 {
    --tw-border-opacity: 1;
    border-color: rgb(122 107 232 / var(--tw-border-opacity, 1))
}
.tw-border-white {
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity, 1))
}
.tw-border-t-transparent {
    border-top-color: transparent
}
.tw-bg-\\[\\#008ACD\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(0 138 205 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#00A28B\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(0 162 139 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#05ACF2\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(5 172 242 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#084E72\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(8 78 114 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#0D554A\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(13 85 74 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#40337B\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(64 51 123 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#444258\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(68 66 88 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#60fab2\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(96 250 178 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#6C4FDB\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(108 79 219 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#7A6BE8\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(122 107 232 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#C7FFF1\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(199 255 241 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#DFF3FE\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(223 243 254 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#E1E8F0\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(225 232 240 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#E2E4FD\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(226 228 253 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#E3F4FD\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(227 244 253 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#EFF1FE\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(239 241 254 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#F1F4F9\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(241 244 249 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#F43F5E\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#F9FAFC\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 252 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#FEE4E5\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(254 228 229 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#FEF3C6\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(254 243 198 / var(--tw-bg-opacity, 1))
}
.tw-bg-\\[\\#e5eaf1\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(229 234 241 / var(--tw-bg-opacity, 1))
}
.tw-bg-alert-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1))
}
.tw-bg-alert-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1))
}
.tw-bg-alert-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1))
}
.tw-bg-black {
    --tw-bg-opacity: 1;
    background-color: rgb(3 6 23 / var(--tw-bg-opacity, 1))
}
.tw-bg-black\\/10 {
    background-color: rgb(3 6 23 / 0.1)
}
.tw-bg-black\\/40 {
    background-color: rgb(3 6 23 / 0.4)
}
.tw-bg-black\\/50 {
    background-color: rgb(3 6 23 / 0.5)
}
.tw-bg-black\\/60 {
    background-color: rgb(3 6 23 / 0.6)
}
.tw-bg-black\\/65 {
    background-color: rgb(3 6 23 / 0.65)
}
.tw-bg-blue-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(223 243 255 / var(--tw-bg-opacity, 1))
}
.tw-bg-blue-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(184 232 255 / var(--tw-bg-opacity, 1))
}
.tw-bg-blue-400 {
    --tw-bg-opacity: 1;
    background-color: rgb(65 200 255 / var(--tw-bg-opacity, 1))
}
.tw-bg-blue-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(239 249 255 / var(--tw-bg-opacity, 1))
}
.tw-bg-blue-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(6 172 241 / var(--tw-bg-opacity, 1))
}
.tw-bg-blue-950 {
    --tw-bg-opacity: 1;
    background-color: rgb(6 48 75 / var(--tw-bg-opacity, 1))
}
.tw-bg-error-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1))
}
.tw-bg-error-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1))
}
.tw-bg-error-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-300 {
    --tw-bg-opacity: 1;
    background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-400 {
    --tw-bg-opacity: 1;
    background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-900 {
    --tw-bg-opacity: 1;
    background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1))
}
.tw-bg-gray-900\\/10 {
    background-color: rgb(15 23 42 / 0.1)
}
.tw-bg-green-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(199 255 241 / var(--tw-bg-opacity, 1))
}
.tw-bg-green-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(144 255 228 / var(--tw-bg-opacity, 1))
}
.tw-bg-green-300 {
    --tw-bg-opacity: 1;
    background-color: rgb(80 248 213 / var(--tw-bg-opacity, 1))
}
.tw-bg-green-400 {
    --tw-bg-opacity: 1;
    background-color: rgb(39 230 196 / var(--tw-bg-opacity, 1))
}
.tw-bg-green-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(4 200 169 / var(--tw-bg-opacity, 1))
}
.tw-bg-green-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(0 162 139 / var(--tw-bg-opacity, 1))
}
.tw-bg-purple {
    --tw-bg-opacity: 1;
    background-color: rgb(122 107 232 / var(--tw-bg-opacity, 1))
}
.tw-bg-purple-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(226 228 253 / var(--tw-bg-opacity, 1))
}
.tw-bg-purple-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(202 205 251 / var(--tw-bg-opacity, 1))
}
.tw-bg-purple-300\\/50 {
    background-color: rgb(170 173 247 / 0.5)
}
.tw-bg-purple-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(239 241 254 / var(--tw-bg-opacity, 1))
}
.tw-bg-purple-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(122 107 232 / var(--tw-bg-opacity, 1))
}
.tw-bg-purple-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(108 80 219 / var(--tw-bg-opacity, 1))
}
.tw-bg-purple-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(75 55 156 / var(--tw-bg-opacity, 1))
}
.tw-bg-transparent {
    background-color: transparent
}
.tw-bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}
.tw-bg-white\\/50 {
    background-color: rgb(255 255 255 / 0.5)
}
.tw-bg-opacity-50 {
    --tw-bg-opacity: 0.5
}
.tw-bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--tw-gradient-stops))
}
.tw-bg-gradient-to-l {
    background-image: linear-gradient(to left, var(--tw-gradient-stops))
}
.tw-bg-none {
    background-image: none
}
.tw-from-\\[\\#5342D1\\] {
    --tw-gradient-from: #5342D1 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(83 66 209 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.tw-from-blue-500 {
    --tw-gradient-from: #06acf1 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(6 172 241 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.tw-via-\\[\\#DC2564\\] {
    --tw-gradient-to: rgb(220 37 100 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #DC2564 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.tw-to-\\[\\#FEC05F\\] {
    --tw-gradient-to: #FEC05F var(--tw-gradient-to-position)
}
.tw-to-purple-500 {
    --tw-gradient-to: #7a6be8 var(--tw-gradient-to-position)
}
.tw-fill-none {
    fill: none
}
.tw-stroke-gray-200 {
    stroke: #e2e8f0
}
.tw-stroke-purple-500 {
    stroke: #7a6be8
}
.tw-object-contain {
    object-fit: contain
}
.tw-object-cover {
    object-fit: cover
}
.tw-p-0 {
    padding: 0px
}
.tw-p-1 {
    padding: 0.25rem
}
.tw-p-10 {
    padding: 2.5rem
}
.tw-p-2 {
    padding: 0.5rem
}
.tw-p-3 {
    padding: 0.75rem
}
.tw-p-4 {
    padding: 1rem
}
.tw-p-5 {
    padding: 1.25rem
}
.tw-p-6 {
    padding: 1.5rem
}
.tw-p-8 {
    padding: 2rem
}
.tw-p-\\[2px\\] {
    padding: 2px
}
.tw-px-0 {
    padding-left: 0px;
    padding-right: 0px
}
.tw-px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem
}
.tw-px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem
}
.tw-px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem
}
.tw-px-20 {
    padding-left: 5rem;
    padding-right: 5rem
}
.tw-px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem
}
.tw-px-4 {
    padding-left: 1rem;
    padding-right: 1rem
}
.tw-px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem
}
.tw-px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem
}
.tw-px-8 {
    padding-left: 2rem;
    padding-right: 2rem
}
.tw-py-0 {
    padding-top: 0px;
    padding-bottom: 0px
}
.tw-py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem
}
.tw-py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem
}
.tw-py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
}
.tw-py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem
}
.tw-py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem
}
.tw-py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem
}
.tw-py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem
}
.tw-py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem
}
.tw-py-\\[10px\\] {
    padding-top: 10px;
    padding-bottom: 10px
}
.tw-py-\\[2px\\] {
    padding-top: 2px;
    padding-bottom: 2px
}
.tw-pb-1 {
    padding-bottom: 0.25rem
}
.tw-pb-10 {
    padding-bottom: 2.5rem
}
.tw-pb-2 {
    padding-bottom: 0.5rem
}
.tw-pb-24 {
    padding-bottom: 6rem
}
.tw-pb-3 {
    padding-bottom: 0.75rem
}
.tw-pb-4 {
    padding-bottom: 1rem
}
.tw-pb-5 {
    padding-bottom: 1.25rem
}
.tw-pe-5 {
    padding-inline-end: 1.25rem
}
.tw-pl-0 {
    padding-left: 0px
}
.tw-pl-10 {
    padding-left: 2.5rem
}
.tw-pl-2 {
    padding-left: 0.5rem
}
.tw-pl-4 {
    padding-left: 1rem
}
.tw-pl-5 {
    padding-left: 1.25rem
}
.tw-pl-8 {
    padding-left: 2rem
}
.tw-pr-10 {
    padding-right: 2.5rem
}
.tw-pr-16 {
    padding-right: 4rem
}
.tw-pr-2 {
    padding-right: 0.5rem
}
.tw-pr-20 {
    padding-right: 5rem
}
.tw-pr-4 {
    padding-right: 1rem
}
.tw-pr-5 {
    padding-right: 1.25rem
}
.tw-pr-6 {
    padding-right: 1.5rem
}
.tw-pr-8 {
    padding-right: 2rem
}
.tw-pr-9 {
    padding-right: 2.25rem
}
.tw-ps-0 {
    padding-inline-start: 0px
}
.tw-pt-1 {
    padding-top: 0.25rem
}
.tw-pt-3 {
    padding-top: 0.75rem
}
.tw-pt-4 {
    padding-top: 1rem
}
.tw-pt-5 {
    padding-top: 1.25rem
}
.tw-pt-\\[60px\\] {
    padding-top: 60px
}
.tw-text-left {
    text-align: left
}
.tw-text-center {
    text-align: center
}
.tw-text-right {
    text-align: right
}
.tw-align-middle {
    vertical-align: middle
}
.tw-font-sans {
    font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
}
.tw-text-2xl {
    font-size: 1.5rem;
    line-height: 2rem
}
.tw-text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem
}
.tw-text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem
}
.tw-text-5xl {
    font-size: 3rem;
    line-height: 1
}
.tw-text-\\[14px\\] {
    font-size: 14px
}
.tw-text-base {
    font-size: 1rem;
    line-height: 1.5rem
}
.tw-text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem
}
.tw-text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem
}
.tw-text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem
}
.tw-text-xs {
    font-size: 0.75rem;
    line-height: 1rem
}
.tw-font-black {
    font-weight: 900
}
.tw-font-bold {
    font-weight: 700
}
.tw-font-medium {
    font-weight: 500
}
.tw-font-normal {
    font-weight: 400
}
.tw-font-semibold {
    font-weight: 600
}
.tw-uppercase {
    text-transform: uppercase
}
.tw-text-\\[\\#008ACD\\] {
    --tw-text-opacity: 1;
    color: rgb(0 138 205 / var(--tw-text-opacity, 1))
}
.tw-text-\\[\\#00A28B\\] {
    --tw-text-opacity: 1;
    color: rgb(0 162 139 / var(--tw-text-opacity, 1))
}
.tw-text-\\[\\#015C89\\] {
    --tw-text-opacity: 1;
    color: rgb(1 92 137 / var(--tw-text-opacity, 1))
}
.tw-text-\\[\\#0F172A\\] {
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1))
}
.tw-text-\\[\\#444258\\] {
    --tw-text-opacity: 1;
    color: rgb(68 66 88 / var(--tw-text-opacity, 1))
}
.tw-text-\\[\\#6C4FDB\\] {
    --tw-text-opacity: 1;
    color: rgb(108 79 219 / var(--tw-text-opacity, 1))
}
.tw-text-\\[\\#94A3B8\\] {
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1))
}
.tw-text-\\[\\#F49E0B\\] {
    --tw-text-opacity: 1;
    color: rgb(244 158 11 / var(--tw-text-opacity, 1))
}
.tw-text-\\[\\#FBBF23\\] {
    --tw-text-opacity: 1;
    color: rgb(251 191 35 / var(--tw-text-opacity, 1))
}
.tw-text-alert-300 {
    --tw-text-opacity: 1;
    color: rgb(252 211 77 / var(--tw-text-opacity, 1))
}
.tw-text-alert-400 {
    --tw-text-opacity: 1;
    color: rgb(251 191 36 / var(--tw-text-opacity, 1))
}
.tw-text-alert-500 {
    --tw-text-opacity: 1;
    color: rgb(245 158 11 / var(--tw-text-opacity, 1))
}
.tw-text-alert-600 {
    --tw-text-opacity: 1;
    color: rgb(217 119 6 / var(--tw-text-opacity, 1))
}
.tw-text-alert-800 {
    --tw-text-opacity: 1;
    color: rgb(146 64 14 / var(--tw-text-opacity, 1))
}
.tw-text-black {
    --tw-text-opacity: 1;
    color: rgb(3 6 23 / var(--tw-text-opacity, 1))
}
.tw-text-black\\/100 {
    color: rgb(3 6 23 / 1)
}
.tw-text-blue-400 {
    --tw-text-opacity: 1;
    color: rgb(65 200 255 / var(--tw-text-opacity, 1))
}
.tw-text-blue-500 {
    --tw-text-opacity: 1;
    color: rgb(6 172 241 / var(--tw-text-opacity, 1))
}
.tw-text-blue-600 {
    --tw-text-opacity: 1;
    color: rgb(0 138 206 / var(--tw-text-opacity, 1))
}
.tw-text-blue-700 {
    --tw-text-opacity: 1;
    color: rgb(0 110 167 / var(--tw-text-opacity, 1))
}
.tw-text-blue-800 {
    --tw-text-opacity: 1;
    color: rgb(2 92 138 / var(--tw-text-opacity, 1))
}
.tw-text-blue-900 {
    --tw-text-opacity: 1;
    color: rgb(8 77 114 / var(--tw-text-opacity, 1))
}
.tw-text-error-500 {
    --tw-text-opacity: 1;
    color: rgb(244 63 94 / var(--tw-text-opacity, 1))
}
.tw-text-error-600 {
    --tw-text-opacity: 1;
    color: rgb(225 29 72 / var(--tw-text-opacity, 1))
}
.tw-text-error-700 {
    --tw-text-opacity: 1;
    color: rgb(190 18 60 / var(--tw-text-opacity, 1))
}
.tw-text-gray-100 {
    --tw-text-opacity: 1;
    color: rgb(241 245 249 / var(--tw-text-opacity, 1))
}
.tw-text-gray-200 {
    --tw-text-opacity: 1;
    color: rgb(226 232 240 / var(--tw-text-opacity, 1))
}
.tw-text-gray-300 {
    --tw-text-opacity: 1;
    color: rgb(203 213 225 / var(--tw-text-opacity, 1))
}
.tw-text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1))
}
.tw-text-gray-500 {
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1))
}
.tw-text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(71 85 105 / var(--tw-text-opacity, 1))
}
.tw-text-gray-700 {
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1))
}
.tw-text-gray-800 {
    --tw-text-opacity: 1;
    color: rgb(30 41 59 / var(--tw-text-opacity, 1))
}
.tw-text-gray-900 {
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1))
}
.tw-text-green-500 {
    --tw-text-opacity: 1;
    color: rgb(4 200 169 / var(--tw-text-opacity, 1))
}
.tw-text-green-600 {
    --tw-text-opacity: 1;
    color: rgb(0 162 139 / var(--tw-text-opacity, 1))
}
.tw-text-green-700 {
    --tw-text-opacity: 1;
    color: rgb(5 128 113 / var(--tw-text-opacity, 1))
}
.tw-text-green-800 {
    --tw-text-opacity: 1;
    color: rgb(9 102 91 / var(--tw-text-opacity, 1))
}
.tw-text-green-900 {
    --tw-text-opacity: 1;
    color: rgb(13 84 75 / var(--tw-text-opacity, 1))
}
.tw-text-purple {
    --tw-text-opacity: 1;
    color: rgb(122 107 232 / var(--tw-text-opacity, 1))
}
.tw-text-purple-400 {
    --tw-text-opacity: 1;
    color: rgb(141 136 241 / var(--tw-text-opacity, 1))
}
.tw-text-purple-500 {
    --tw-text-opacity: 1;
    color: rgb(122 107 232 / var(--tw-text-opacity, 1))
}
.tw-text-purple-600 {
    --tw-text-opacity: 1;
    color: rgb(108 80 219 / var(--tw-text-opacity, 1))
}
.tw-text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
.tw-underline {
    text-decoration-line: underline
}
.tw-placeholder-gray-400::placeholder {
    --tw-placeholder-opacity: 1;
    color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1))
}
.tw-accent-purple-500 {
    accent-color: #7a6be8
}
.tw-opacity-0 {
    opacity: 0
}
.tw-opacity-100 {
    opacity: 1
}
.tw-opacity-30 {
    opacity: 0.3
}
.tw-opacity-50 {
    opacity: 0.5
}
.tw-opacity-70 {
    opacity: 0.7
}
.tw-opacity-\\[\\.2\\] {
    opacity: .2
}
.tw-shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.tw-shadow-\\[0_0_4px_4px_rgba\\(170\\,173\\,247\\,0\\.5\\)\\] {
    --tw-shadow: 0 0 4px 4px rgba(170,173,247,0.5);
    --tw-shadow-colored: 0 0 4px 4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.tw-shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.tw-shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.tw-shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.tw-shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.tw-outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px
}
.tw-backdrop-blur-\\[2px\\] {
    --tw-backdrop-blur: blur(2px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)
}
.tw-backdrop-blur-\\[3px\\] {
    --tw-backdrop-blur: blur(3px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)
}
.tw-backdrop-blur-sm {
    --tw-backdrop-blur: blur(4px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)
}
.tw-transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.tw-transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.tw-transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.tw-transition-transform {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.tw-duration-100 {
    transition-duration: 100ms
}
.tw-duration-200 {
    transition-duration: 200ms
}
.tw-duration-300 {
    transition-duration: 300ms
}
.tw-duration-500 {
    transition-duration: 500ms
}
.tw-ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
@keyframes enter {
    from {
        opacity: var(--tw-enter-opacity, 1);
        transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))
    }
}
@keyframes exit {
    to {
        opacity: var(--tw-exit-opacity, 1);
        transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))
    }
}
.tw-duration-100 {
    animation-duration: 100ms
}
.tw-duration-200 {
    animation-duration: 200ms
}
.tw-duration-300 {
    animation-duration: 300ms
}
.tw-duration-500 {
    animation-duration: 500ms
}
.tw-ease-in-out {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
.\\[writing-mode\\:vertical-rl\\] {
    writing-mode: vertical-rl
}

/*
@layer base {
	:root {
		--background: 0 0% 100%;
		--foreground: 222.2 47.4% 11.2%;

		--muted: 210 40% 96.1%;
		--muted-foreground: 215.4 16.3% 46.9%;

		--popover: 0 0% 100%;
		--popover-foreground: 222.2 47.4% 11.2%;

		--border: 214.3 31.8% 91.4%;
		--input: 214.3 31.8% 91.4%;

		--card: 0 0% 100%;
		--card-foreground: 222.2 47.4% 11.2%;

		--primary: 222.2 47.4% 11.2%;
		--primary-foreground: 210 40% 98%;

		--secondary: 210 40% 96.1%;
		--secondary-foreground: 222.2 47.4% 11.2%;

		--accent: 210 40% 96.1%;
		--accent-foreground: 222.2 47.4% 11.2%;

		--destructive: 0 100% 50%;
		--destructive-foreground: 210 40% 98%;

		--ring: 215 20.2% 65.1%;

		--radius: 0.5rem;
	}

	.dark {
		--background: 224 71% 4%;
		--foreground: 213 31% 91%;

		--muted: 223 47% 11%;
		--muted-foreground: 215.4 16.3% 56.9%;

		--accent: 216 34% 17%;
		--accent-foreground: 210 40% 98%;

		--popover: 224 71% 4%;
		--popover-foreground: 215 20.2% 65.1%;

		--border: 216 34% 17%;
		--input: 216 34% 17%;

		--card: 224 71% 4%;
		--card-foreground: 213 31% 91%;

		--primary: 210 40% 98%;
		--primary-foreground: 222.2 47.4% 1.2%;

		--secondary: 222.2 47.4% 11.2%;
		--secondary-foreground: 210 40% 98%;

		--destructive: 0 63% 31%;
		--destructive-foreground: 210 40% 98%;

		--ring: 216 34% 17%;

		--radius: 0.5rem;
	}
}

 @layer base {
	* {
		@apply border-border;
	}
	body {
		@apply bg-background text-foreground;
		font-feature-settings: 'rlig' 1, 'calt' 1;
	}
}
*/

.hover\\:tw-scale-110:hover {
    --tw-scale-x: 1.1;
    --tw-scale-y: 1.1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

.hover\\:tw-cursor-pointer:hover {
    cursor: pointer
}

.hover\\:tw-bg-\\[\\#05ACF2\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(5 172 242 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-\\[\\#5F52C4\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(95 82 196 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-\\[\\#CF0025\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(207 0 37 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-\\[\\#DFE9F8\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(223 233 248 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-\\[\\#EFF1FE\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(239 241 254 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-\\[\\#F49E0B\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(244 158 11 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-\\[\\#FEF3C6\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(254 243 198 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-blue-400:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(65 200 255 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-error-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(254 205 211 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-error-500:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-error-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-error-800:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(159 18 57 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-gray-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-gray-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-gray-300:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-gray-50:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-gray-800:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-green-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(0 162 139 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-purple:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(122 107 232 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-purple-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(226 228 253 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-purple-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(202 205 251 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-purple-400:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(141 136 241 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-purple-50:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(239 241 254 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-purple-500:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(122 107 232 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-purple-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(108 80 219 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-purple-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(93 65 193 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-purple-800:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(75 55 156 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-white:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}

.hover\\:tw-bg-white\\/25:hover {
    background-color: rgb(255 255 255 / 0.25)
}

.hover\\:tw-text-\\[\\#3e3e3e\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(62 62 62 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-alert-400:hover {
    --tw-text-opacity: 1;
    color: rgb(251 191 36 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-black:hover {
    --tw-text-opacity: 1;
    color: rgb(3 6 23 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-blue-600:hover {
    --tw-text-opacity: 1;
    color: rgb(0 138 206 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-blue-700:hover {
    --tw-text-opacity: 1;
    color: rgb(0 110 167 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-error-700:hover {
    --tw-text-opacity: 1;
    color: rgb(190 18 60 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-gray-600:hover {
    --tw-text-opacity: 1;
    color: rgb(71 85 105 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-gray-700:hover {
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-gray-800:hover {
    --tw-text-opacity: 1;
    color: rgb(30 41 59 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-purple-200:hover {
    --tw-text-opacity: 1;
    color: rgb(202 205 251 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-purple-400:hover {
    --tw-text-opacity: 1;
    color: rgb(141 136 241 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-purple-500:hover {
    --tw-text-opacity: 1;
    color: rgb(122 107 232 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-purple-700:hover {
    --tw-text-opacity: 1;
    color: rgb(93 65 193 / var(--tw-text-opacity, 1))
}

.hover\\:tw-text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.hover\\:tw-underline:hover {
    text-decoration-line: underline
}

.hover\\:tw-shadow:hover {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.hover\\:tw-brightness-110:hover {
    --tw-brightness: brightness(1.1);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}

.focus\\:tw-border-purple-500:focus {
    --tw-border-opacity: 1;
    border-color: rgb(122 107 232 / var(--tw-border-opacity, 1))
}

.focus\\:tw-outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px
}

.focus\\:tw-ring-1:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)
}

.focus\\:tw-ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)
}

.focus\\:tw-ring-purple-500:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(122 107 232 / var(--tw-ring-opacity, 1))
}

.active\\:tw-border:active {
    border-width: 1px
}

.active\\:tw-bg-\\[\\#00468A\\]:active {
    --tw-bg-opacity: 1;
    background-color: rgb(0 70 138 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-error-300:active {
    --tw-bg-opacity: 1;
    background-color: rgb(253 164 175 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-error-500:active {
    --tw-bg-opacity: 1;
    background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-error-700:active {
    --tw-bg-opacity: 1;
    background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-gray-100:active {
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-gray-200:active {
    --tw-bg-opacity: 1;
    background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-gray-200\\/75:active {
    background-color: rgb(226 232 240 / 0.75)
}

.active\\:tw-bg-gray-300:active {
    --tw-bg-opacity: 1;
    background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-purple:active {
    --tw-bg-opacity: 1;
    background-color: rgb(122 107 232 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-purple-300:active {
    --tw-bg-opacity: 1;
    background-color: rgb(170 173 247 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-purple-400:active {
    --tw-bg-opacity: 1;
    background-color: rgb(141 136 241 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-purple-600:active {
    --tw-bg-opacity: 1;
    background-color: rgb(108 80 219 / var(--tw-bg-opacity, 1))
}

.active\\:tw-bg-purple-700:active {
    --tw-bg-opacity: 1;
    background-color: rgb(93 65 193 / var(--tw-bg-opacity, 1))
}

.active\\:tw-text-purple-600:active {
    --tw-text-opacity: 1;
    color: rgb(108 80 219 / var(--tw-text-opacity, 1))
}

.active\\:tw-text-white:active {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.active\\:tw-shadow-\\[inset_0_2px_2px_0px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.4\\)\\]:active {
    --tw-shadow: inset 0 2px 2px 0px rgba(255,255,255,0.4);
    --tw-shadow-colored: inset 0 2px 2px 0px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.disabled\\:tw-bg-gray-200:disabled {
    --tw-bg-opacity: 1;
    background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1))
}

.disabled\\:tw-bg-gray-300:disabled {
    --tw-bg-opacity: 1;
    background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1))
}

.disabled\\:tw-bg-white:disabled {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}

.disabled\\:tw-text-gray-400:disabled {
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1))
}

.disabled\\:tw-text-gray-500:disabled {
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1))
}

.disabled\\:tw-opacity-20:disabled {
    opacity: 0.2
}

@media (min-width: 640px) {
    .sm\\:tw-ml-0 {
        margin-left: 0px
    }
    .sm\\:tw-block {
        display: block
    }
    .sm\\:tw-w-64 {
        width: 16rem
    }
    .sm\\:tw-w-auto {
        width: auto
    }
    .sm\\:tw-flex-row {
        flex-direction: row
    }
    .sm\\:tw-items-center {
        align-items: center
    }
    .sm\\:tw-gap-6 {
        gap: 1.5rem
    }
}

@media (min-width: 768px) {
    .md\\:tw-col-span-1 {
        grid-column: span 1 / span 1
    }
    .md\\:tw-col-span-2 {
        grid-column: span 2 / span 2
    }
    .md\\:tw-col-span-4 {
        grid-column: span 4 / span 4
    }
    .md\\:tw-col-span-5 {
        grid-column: span 5 / span 5
    }
    .md\\:tw-block {
        display: block
    }
    .md\\:tw-h-\\[80vh\\] {
        height: 80vh
    }
    .md\\:tw-w-5\\/12 {
        width: 41.666667%
    }
    .md\\:tw-w-\\[500px\\] {
        width: 500px
    }
    .md\\:tw-w-\\[90\\%\\] {
        width: 90%
    }
    .md\\:tw-w-\\[900px\\] {
        width: 900px
    }
    .md\\:tw-max-w-\\[180px\\] {
        max-width: 180px
    }
    .md\\:tw-flex-row {
        flex-direction: row
    }
    .md\\:tw-items-center {
        align-items: center
    }
    .md\\:tw-gap-3 {
        gap: 0.75rem
    }
    .md\\:tw-gap-6 {
        gap: 1.5rem
    }
    .md\\:tw-p-5 {
        padding: 1.25rem
    }
    .md\\:tw-p-6 {
        padding: 1.5rem
    }
    .md\\:tw-px-4 {
        padding-left: 1rem;
        padding-right: 1rem
    }
    .md\\:tw-py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem
    }
    .md\\:tw-pr-2 {
        padding-right: 0.5rem
    }
    .md\\:tw-text-3xl {
        font-size: 1.875rem;
        line-height: 2.25rem
    }
    .md\\:tw-text-base {
        font-size: 1rem;
        line-height: 1.5rem
    }
    .md\\:tw-text-xs {
        font-size: 0.75rem;
        line-height: 1rem
    }
}

@media (min-width: 1024px) {
    .lg\\:tw-col-span-1 {
        grid-column: span 1 / span 1
    }
    .lg\\:tw-col-span-2 {
        grid-column: span 2 / span 2
    }
    .lg\\:tw-col-span-4 {
        grid-column: span 4 / span 4
    }
    .lg\\:tw-col-span-5 {
        grid-column: span 5 / span 5
    }
    .lg\\:tw-w-\\[816px\\] {
        width: 816px
    }
    .lg\\:tw-max-w-\\[220px\\] {
        max-width: 220px
    }
    .lg\\:tw-grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
    .lg\\:tw-grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr))
    }
    .lg\\:tw-grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr))
    }
    .lg\\:tw-gap-3 {
        gap: 0.75rem
    }
    .lg\\:tw-gap-x-3 {
        column-gap: 0.75rem
    }
    .lg\\:tw-gap-y-4 {
        row-gap: 1rem
    }
    .lg\\:tw-space-x-5 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(1.25rem * var(--tw-space-x-reverse));
        margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)))
    }
    .lg\\:tw-space-y-10 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(2.5rem * var(--tw-space-y-reverse))
    }
    .lg\\:tw-pr-4 {
        padding-right: 1rem
    }
    .lg\\:tw-text-lg {
        font-size: 1.125rem;
        line-height: 1.75rem
    }
}

@media (min-width: 1280px) {
    .xl\\:tw-flex {
        display: flex
    }
    .xl\\:tw-w-fit {
        width: fit-content
    }
    .xl\\:tw-min-w-\\[850px\\] {
        min-width: 850px
    }
    .xl\\:tw-gap-2 {
        gap: 0.5rem
    }
    .xl\\:tw-pr-6 {
        padding-right: 1.5rem
    }
    .xl\\:tw-text-base {
        font-size: 1rem;
        line-height: 1.5rem
    }
    .xl\\:tw-text-lg {
        font-size: 1.125rem;
        line-height: 1.75rem
    }
    .xl\\:tw-text-sm {
        font-size: 0.875rem;
        line-height: 1.25rem
    }
    .xl\\:tw-text-xl {
        font-size: 1.25rem;
        line-height: 1.75rem
    }
}

@media (min-width: 1366px) {
    .desktop\\:tw-fixed {
        position: fixed
    }
    .desktop\\:tw-block {
        display: block
    }
    .desktop\\:tw-hidden {
        display: none
    }
    .desktop\\:tw-h-\\[calc\\(100vh_-_245px\\)\\] {
        height: calc(100vh - 245px)
    }
    .desktop\\:tw-h-full {
        height: 100%
    }
    .desktop\\:tw-w-\\[380px\\] {
        width: 380px
    }
    .desktop\\:tw-flex-row {
        flex-direction: row
    }
    .desktop\\:tw-pr-8 {
        padding-right: 2rem
    }
    .desktop\\:tw-text-base {
        font-size: 1rem;
        line-height: 1.5rem
    }
    .desktop\\:tw-text-xl {
        font-size: 1.25rem;
        line-height: 1.75rem
    }
}

@media (min-width: 1536px) {
    .\\32xl\\:tw-ml-10 {
        margin-left: 2.5rem
    }
    .\\32xl\\:tw-mr-16 {
        margin-right: 4rem
    }
    .\\32xl\\:tw-mt-0 {
        margin-top: 0px
    }
    .\\32xl\\:tw-block {
        display: block
    }
    .\\32xl\\:tw-inline {
        display: inline
    }
    .\\32xl\\:tw-flex {
        display: flex
    }
    .\\32xl\\:tw-hidden {
        display: none
    }
    .\\32xl\\:tw-h-14 {
        height: 3.5rem
    }
    .\\32xl\\:tw-h-5 {
        height: 1.25rem
    }
    .\\32xl\\:tw-h-\\[60px\\] {
        height: 60px
    }
    .\\32xl\\:tw-h-\\[700px\\] {
        height: 700px
    }
    .\\32xl\\:tw-max-h-\\[720px\\] {
        max-height: 720px
    }
    .\\32xl\\:tw-w-1\\/5 {
        width: 20%
    }
    .\\32xl\\:tw-w-14 {
        width: 3.5rem
    }
    .\\32xl\\:tw-w-2\\/5 {
        width: 40%
    }
    .\\32xl\\:tw-w-3\\/5 {
        width: 60%
    }
    .\\32xl\\:tw-w-5 {
        width: 1.25rem
    }
    .\\32xl\\:tw-w-\\[381px\\] {
        width: 381px
    }
    .\\32xl\\:tw-w-\\[60px\\] {
        width: 60px
    }
    .\\32xl\\:tw-flex-row {
        flex-direction: row
    }
    .\\32xl\\:tw-flex-col {
        flex-direction: column
    }
    .\\32xl\\:tw-items-center {
        align-items: center
    }
    .\\32xl\\:tw-justify-between {
        justify-content: space-between
    }
    .\\32xl\\:tw-gap-4 {
        gap: 1rem
    }
    .\\32xl\\:tw-gap-5 {
        gap: 1.25rem
    }
    .\\32xl\\:tw-gap-8 {
        gap: 2rem
    }
    .\\32xl\\:tw-space-x-2 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(0.5rem * var(--tw-space-x-reverse));
        margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))
    }
    .\\32xl\\:tw-space-y-0 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(0px * var(--tw-space-y-reverse))
    }
    .\\32xl\\:tw-space-y-4 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(1rem * var(--tw-space-y-reverse))
    }
    .\\32xl\\:tw-p-4 {
        padding: 1rem
    }
    .\\32xl\\:tw-pr-10 {
        padding-right: 2.5rem
    }
    .\\32xl\\:tw-text-2xl {
        font-size: 1.5rem;
        line-height: 2rem
    }
    .\\32xl\\:tw-text-base {
        font-size: 1rem;
        line-height: 1.5rem
    }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/index.css"],"names":[],"mappings":"AAAA;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,qCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,qCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAEd;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,sBAAmB;IAAnB,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,SAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,oDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,oDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,4DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,4DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4DAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,4DAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,qEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0EAAmB;IAAnB,8FAAmB;IAAnB;AAAmB;AAAnB;IAAA,8CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+EAAmB;IAAnB,mGAAmB;IAAnB;AAAmB;AAAnB;IAAA,6EAAmB;IAAnB,iGAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gFAAmB;IAAnB,oGAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,wJAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+FAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA,mCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;QAAA,kCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;;AAEnB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA8EC;;AAlFD;IAAA,iBAmFA;IAnFA,iBAmFA;IAnFA;AAmFA;;AAnFA;IAAA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA;AAmFA;;AAnFA;IAAA,0EAmFA;IAnFA,8FAmFA;IAnFA;AAmFA;;AAnFA;IAAA,gCAmFA;IAnFA;AAmFA;;AAnFA;IAAA,sBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,8BAmFA;IAnFA;AAmFA;;AAnFA;IAAA,2GAmFA;IAnFA,yGAmFA;IAnFA;AAmFA;;AAnFA;IAAA,2GAmFA;IAnFA,yGAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,sDAmFA;IAnFA,+DAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,kBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA,oBAmFA;IAnFA;AAmFA;;AAnFA;IAAA;AAmFA;;AAnFA;IAAA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;AAAA;;AAnFA;IAAA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA,kBAmFA;QAnFA;IAmFA;IAnFA;QAAA,iBAmFA;QAnFA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA,mBAmFA;QAnFA;IAmFA;IAnFA;QAAA,eAmFA;QAnFA;IAmFA;IAnFA;QAAA,kBAmFA;QAnFA;IAmFA;AAAA;;AAnFA;IAAA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA,uBAmFA;QAnFA,uDAmFA;QAnFA;IAmFA;IAnFA;QAAA,uBAmFA;QAnFA,8DAmFA;QAnFA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA,mBAmFA;QAnFA;IAmFA;AAAA;;AAnFA;IAAA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA,eAmFA;QAnFA;IAmFA;IAnFA;QAAA,mBAmFA;QAnFA;IAmFA;IAnFA;QAAA,mBAmFA;QAnFA;IAmFA;IAnFA;QAAA,kBAmFA;QAnFA;IAmFA;AAAA;;AAnFA;IAAA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA,eAmFA;QAnFA;IAmFA;IAnFA;QAAA,kBAmFA;QAnFA;IAmFA;AAAA;;AAnFA;IAAA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA,uBAmFA;QAnFA,sDAmFA;QAnFA;IAmFA;IAnFA;QAAA,uBAmFA;QAnFA,2DAmFA;QAnFA;IAmFA;IAnFA;QAAA,uBAmFA;QAnFA,4DAmFA;QAnFA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA;IAmFA;IAnFA;QAAA,iBAmFA;QAnFA;IAmFA;IAnFA;QAAA,eAmFA;QAnFA;IAmFA;AAAA","sourcesContent":["@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n/*\r\n@layer base {\r\n\t:root {\r\n\t\t--background: 0 0% 100%;\r\n\t\t--foreground: 222.2 47.4% 11.2%;\r\n\r\n\t\t--muted: 210 40% 96.1%;\r\n\t\t--muted-foreground: 215.4 16.3% 46.9%;\r\n\r\n\t\t--popover: 0 0% 100%;\r\n\t\t--popover-foreground: 222.2 47.4% 11.2%;\r\n\r\n\t\t--border: 214.3 31.8% 91.4%;\r\n\t\t--input: 214.3 31.8% 91.4%;\r\n\r\n\t\t--card: 0 0% 100%;\r\n\t\t--card-foreground: 222.2 47.4% 11.2%;\r\n\r\n\t\t--primary: 222.2 47.4% 11.2%;\r\n\t\t--primary-foreground: 210 40% 98%;\r\n\r\n\t\t--secondary: 210 40% 96.1%;\r\n\t\t--secondary-foreground: 222.2 47.4% 11.2%;\r\n\r\n\t\t--accent: 210 40% 96.1%;\r\n\t\t--accent-foreground: 222.2 47.4% 11.2%;\r\n\r\n\t\t--destructive: 0 100% 50%;\r\n\t\t--destructive-foreground: 210 40% 98%;\r\n\r\n\t\t--ring: 215 20.2% 65.1%;\r\n\r\n\t\t--radius: 0.5rem;\r\n\t}\r\n\r\n\t.dark {\r\n\t\t--background: 224 71% 4%;\r\n\t\t--foreground: 213 31% 91%;\r\n\r\n\t\t--muted: 223 47% 11%;\r\n\t\t--muted-foreground: 215.4 16.3% 56.9%;\r\n\r\n\t\t--accent: 216 34% 17%;\r\n\t\t--accent-foreground: 210 40% 98%;\r\n\r\n\t\t--popover: 224 71% 4%;\r\n\t\t--popover-foreground: 215 20.2% 65.1%;\r\n\r\n\t\t--border: 216 34% 17%;\r\n\t\t--input: 216 34% 17%;\r\n\r\n\t\t--card: 224 71% 4%;\r\n\t\t--card-foreground: 213 31% 91%;\r\n\r\n\t\t--primary: 210 40% 98%;\r\n\t\t--primary-foreground: 222.2 47.4% 1.2%;\r\n\r\n\t\t--secondary: 222.2 47.4% 11.2%;\r\n\t\t--secondary-foreground: 210 40% 98%;\r\n\r\n\t\t--destructive: 0 63% 31%;\r\n\t\t--destructive-foreground: 210 40% 98%;\r\n\r\n\t\t--ring: 216 34% 17%;\r\n\r\n\t\t--radius: 0.5rem;\r\n\t}\r\n}\r\n\r\n @layer base {\r\n\t* {\r\n\t\t@apply border-border;\r\n\t}\r\n\tbody {\r\n\t\t@apply bg-background text-foreground;\r\n\t\tfont-feature-settings: 'rlig' 1, 'calt' 1;\r\n\t}\r\n}\r\n*/\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
